"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CardProductTile = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PropertyProvider = require("../../../utils/PropertyProvider/PropertyProvider");
var _CardProductCtaLinks = require("../CardProductCtaLinks/CardProductCtaLinks");
var _CardProductHeader = require("../CardProductHeader/CardProductHeader");
var _CardProductDescriptions = require("../CardProductDescriptions/CardProductDescriptions");
var _CardProductFeatures = require("../CardProductFeatures/CardProductFeatures");
var _CardProductWelcomeOffer = require("../CardProductWelcomeOffer/CardProductWelcomeOffer");
var _excluded = ["styles", "ImageComponent", "imageComponentProps", "TitleComponent", "titleComponentProps", "productFeatures", "productWelcomeOffer", "productDescription", "productFootnotes", "productLinks", "className", "namespace", "dtm", "productType", "productTitle", "ariaCardTitle", "productImage", "qeId", "collapsableOnMobile", "cardIndex"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var arrayHasLength = function arrayHasLength(arr) {
  return !!(arr && arr.length);
};
var CardProductTile = exports.CardProductTile = function CardProductTile(_ref) {
  var styles = _ref.styles,
    ImageComponent = _ref.ImageComponent,
    imageComponentProps = _ref.imageComponentProps,
    TitleComponent = _ref.TitleComponent,
    titleComponentProps = _ref.titleComponentProps,
    productFeatures = _ref.productFeatures,
    productWelcomeOffer = _ref.productWelcomeOffer,
    productDescription = _ref.productDescription,
    productFootnotes = _ref.productFootnotes,
    productLinks = _ref.productLinks,
    className = _ref.className,
    namespace = _ref.namespace,
    dtm = _ref.dtm,
    productType = _ref.productType,
    productTitle = _ref.productTitle,
    ariaCardTitle = _ref.ariaCardTitle,
    productImage = _ref.productImage,
    qeId = _ref.qeId,
    collapsableOnMobile = _ref.collapsableOnMobile,
    cardIndex = _ref.cardIndex,
    containerProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)(cardIndex !== 0),
    _useState2 = _slicedToArray(_useState, 2),
    collapsed = _useState2[0],
    setCollapsed = _useState2[1];
  var toggleCollapsed = function toggleCollapsed() {
    setCollapsed(!collapsed);
  };
  var headerProps = {
    ImageComponent: ImageComponent,
    imageComponentProps: imageComponentProps,
    TitleComponent: TitleComponent,
    titleComponentProps: titleComponentProps
  };
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: (0, _classnames["default"])(className, 'product-tile'),
    "data-qe-id": qeId
  }, containerProps), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.productHeaderContainer
  }, /*#__PURE__*/_react["default"].createElement(_CardProductHeader.CardProductHeader, _extends({}, headerProps, {
    styles: styles,
    dtm: dtm,
    namespace: (0, _PropertyProvider.NS)(namespace, 'header'),
    qeId: qeId,
    collapsableOnMobile: collapsableOnMobile,
    toggleCollapsed: toggleCollapsed,
    collapsed: collapsed,
    ariaCardTitle: ariaCardTitle
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(styles.productBodyContainer, _defineProperty({}, styles.collapsed, collapsed && collapsableOnMobile))
  }, arrayHasLength(productDescription) && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.productDescriptions
  }, /*#__PURE__*/_react["default"].createElement(_CardProductDescriptions.CardProductDescriptions, {
    descriptions: productDescription,
    styles: styles,
    dtm: dtm,
    namespace: (0, _PropertyProvider.NS)(namespace, 'description')
  })), arrayHasLength(productFeatures) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-features"
  }, /*#__PURE__*/_react["default"].createElement(_CardProductFeatures.CardProductFeatures, {
    productFeatures: productFeatures,
    styles: styles,
    dtm: dtm,
    namespace: (0, _PropertyProvider.NS)(namespace, 'features')
  })), productWelcomeOffer && /*#__PURE__*/_react["default"].createElement("div", {
    className: "product-welcome-offer"
  }, /*#__PURE__*/_react["default"].createElement(_CardProductWelcomeOffer.CardProductWelcomeOffer, {
    productWelcomeOffer: productWelcomeOffer,
    styles: styles,
    namespace: (0, _PropertyProvider.NS)(namespace, 'welcome-offer')
  })), arrayHasLength(productFootnotes) && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.productFootnotes
  }, /*#__PURE__*/_react["default"].createElement(_CardProductDescriptions.CardProductDescriptions, {
    descriptions: productFootnotes,
    styles: styles,
    className: styles.productFootnotes,
    dtm: dtm,
    namespace: (0, _PropertyProvider.NS)(namespace, 'productFootnotes'),
    name: "productFootnotes"
  })), arrayHasLength(productLinks) && /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.productLinks
  }, /*#__PURE__*/_react["default"].createElement(_CardProductCtaLinks.CardProductCtaLinks, {
    productLinks: productLinks,
    styles: styles,
    className: styles.productCtaLinks,
    dtm: dtm,
    namespace: (0, _PropertyProvider.NS)(namespace, 'cta'),
    qeId: qeId
  }))));
};
var _CardProductHeader$pr = _CardProductHeader.CardProductHeader.propTypes,
  ImageComponent = _CardProductHeader$pr.ImageComponent,
  imageComponentProps = _CardProductHeader$pr.imageComponentProps,
  TitleComponent = _CardProductHeader$pr.TitleComponent,
  titleComponentProps = _CardProductHeader$pr.titleComponentProps;
var productDescription = _CardProductDescriptions.CardProductDescriptions.propTypes.descriptions;
var productFootnotes = productDescription;
var productFeatures = _CardProductFeatures.CardProductFeatures.propTypes.productFeatures;
var productLinks = _CardProductCtaLinks.CardProductCtaLinks.propTypes.productLinks;
CardProductTile.propTypes = {
  styles: _propTypes["default"].objectOf(_propTypes["default"].string),
  ImageComponent: ImageComponent,
  imageComponentProps: imageComponentProps,
  TitleComponent: TitleComponent,
  titleComponentProps: titleComponentProps,
  productFeatures: productFeatures,
  productWelcomeOffer: _propTypes["default"].objectOf(_propTypes["default"].string),
  productDescription: productDescription,
  productFootnotes: productFootnotes,
  productLinks: productLinks,
  productImage: _propTypes["default"].objectOf(_propTypes["default"].string),
  productTitle: _propTypes["default"].string,
  productType: _propTypes["default"].string,
  className: _propTypes["default"].string,
  namespace: _propTypes["default"].string,
  dtm: _propTypes["default"].objectOf(_propTypes["default"].object),
  qeId: _propTypes["default"].string,
  collapsableOnMobile: _propTypes["default"].bool,
  cardIndex: _propTypes["default"].number
};
CardProductTile.defaultProps = {
  ImageComponent: undefined,
  imageComponentProps: {},
  TitleComponent: undefined,
  titleComponentProps: {},
  productDescription: undefined,
  productFootnotes: undefined,
  productFeatures: undefined,
  productWelcomeOffer: undefined,
  productTitle: undefined,
  productType: undefined,
  productLinks: undefined,
  productImage: {},
  styles: {},
  className: '',
  namespace: '',
  dtm: {},
  qeId: undefined,
  collapsableOnMobile: false,
  cardIndex: undefined
};